var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn && !_vm.isWishList
      ? _c("div", [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: {
                href: _vm.$ceres.urls.myAccount,
                id: "accountMenuList",
                "aria-label": _vm.$translate("Ceres::Template.loginMyAccount"),
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "fa-user mr-0 d-lg-none",
                  attrs: {
                    width: "15px",
                    height: "15px",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d: "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-user mr-0 d-none d-lg-inline",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn && !_vm.isWishList
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate("Ceres::Template.login"),
                  },
                  on: {
                    click: function ($event) {
                      _vm.createLoginModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "fa-user mr-0 d-lg-none",
                      attrs: {
                        width: "15px",
                        height: "15px",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 448 512",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d: "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-user mr-0 d-none d-lg-inline",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn && _vm.isWishList ? _c("div") : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn && _vm.isWishList
      ? _c("div", { staticClass: "wishlist-container" }, [
          _c("div", { staticClass: "wishlist-login-info" }, [
            _c("span", { staticClass: "wishlist-text" }, [
              _vm._v(
                _vm._s(_vm.$translate("GonserDT::Template.wishListLoginInfo"))
              ),
            ]),
            _vm._v(" "),
            _vm.showLogin
              ? _c(
                  "a",
                  {
                    staticClass: "nav-link login-button",
                    attrs: {
                      "data-testing": "login-select",
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                      "aria-label": _vm.$translate("Ceres::Template.login"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "GonserDT::Template.wishListLoginButton"
                          )
                        ) +
                        " \n                "
                    ),
                    _c("i", {
                      staticClass: "fa fa-user",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }